import { ArchiveServices } from './archive.services';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from './../shared/appShared.module';
import { RouterModule } from '@angular/router';
import { ArchiveComponent } from './archive.component';
import { ArchiveTreeDataResolver } from './archive.resolver.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EcplDocumentTreeModule } from '../../shared/ecpl-document-tree/ecpl-document-tree.module';
import { EcplDocumentExplorerModule } from '../../shared/ecpl-document-explorer';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


@NgModule({ declarations: [
        ArchiveComponent
    ],
    exports: [
        ArchiveComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe, TranslateDirective,
        AppSharedModule,
        RouterModule,
        EcplDocumentTreeModule,
        EcplDocumentExplorerModule,
        ModalModule
    ],
    providers: [ArchiveServices, ArchiveTreeDataResolver, provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ArchiveModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: ArchiveModule
        };
    }
}
